export default __webpack_public_path__ + "static/media/img-home-02.90e7cf34.jpg";